export type Env = 'live' | 'sandbox';

const KEY = 'env';

let _mmkv: {getString(k: string): string | undefined; set(k: string, v: string): void} | null | undefined;

function mmkv() {
  if (_mmkv !== undefined) return _mmkv;
  try {
    const {MMKV} = require('react-native-mmkv');
    _mmkv = new MMKV({id: 'bootstrap'});
  } catch {
    _mmkv = null;
  }
  return _mmkv;
}

export function getEnvOverride(): Env | undefined {
  try {
    const v = mmkv()?.getString(KEY);
    return v === 'sandbox' || v === 'live' ? v : undefined;
  } catch {
    return undefined;
  }
}

export function setEnvOverride(env: Env) {
  try {
    mmkv()?.set(KEY, env);
  } catch {}
}
